/**
 * Dev-only query error inspector for failed Supabase requests.
 * Captures structured details for debugging.
 */

import { getDebugFlags } from "./debugFlags";
import { classifySupabaseError, type ClassifiedError } from "./errorClassifier";

export interface QueryErrorContext {
  queryName: string;
  flow?: string;
  table?: string;
  view?: string;
  selectClause?: string;
  filters?: Record<string, unknown>;
  sort?: unknown;
  pagination?: { limit?: number; offset?: number };
  responseError?: unknown;
}

export function inspectQueryError(ctx: QueryErrorContext): ClassifiedError & { context: QueryErrorContext } {
  const classified = classifySupabaseError(ctx.responseError ?? new Error("Unknown error"));
  const flags = getDebugFlags();

  if (flags.errorClassification || flags.flowDiagnostics) {
    const payload = {
      queryName: ctx.queryName,
      flow: ctx.flow,
      table: ctx.table,
      view: ctx.view,
      filters: ctx.filters,
      sort: ctx.sort,
      pagination: ctx.pagination,
      classified: {
        class: classified.class,
        hint: classified.hint,
        code: classified.code,
      },
    };
    console.warn("[StudyDo query error]", payload);
  }

  return { ...classified, context: ctx };
}
